/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Venue_TbcInputs */

const th_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รอประกาศสนาม`)
};

const en_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venue TBC`)
};

const ja_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会場未定`)
};

const zh_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`场馆待定`)
};

const es_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pabellón por confirmar`)
};

const pt_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginásio a confirmar`)
};

const id_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat belum ditentukan`)
};

const fr_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salle à confirmer`)
};

const tl_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang venue`)
};

const vi_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có địa điểm`)
};

const ko_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기장 미정`)
};

const de_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halle offen`)
};

const ru_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Площадка не определена`)
};

const tr_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salon belirsiz`)
};

const it_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impianto da definire`)
};

const pl_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hala do ustalenia`)
};

const uk_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Майданчик не визначено`)
};

const hi_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थल तय नहीं`)
};

const ar_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصالة غير محددة`)
};

const ms_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat belum ditetapkan`)
};

const bn_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাঠ ঠিক হয়নি`)
};

const zh_tw2_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`場館未定`)
};

const zh_hk2_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`場館未定`)
};

const ur_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقام طے نہیں`)
};

const fa_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سالن مشخص نیست`)
};

const sw_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukumbi haujapangwa`)
};

const nl_venue_tbc = /** @type {(inputs: Venue_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaal nog onbekend`)
};

/**
* | output |
* | --- |
* | "Venue TBC" |
*
* @param {Venue_TbcInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const venue_tbc = /** @type {((inputs?: Venue_TbcInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Venue_TbcInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_venue_tbc(inputs)
	if (locale === "ja") return ja_venue_tbc(inputs)
	if (locale === "zh") return zh_venue_tbc(inputs)
	if (locale === "es") return es_venue_tbc(inputs)
	if (locale === "pt") return pt_venue_tbc(inputs)
	if (locale === "id") return id_venue_tbc(inputs)
	if (locale === "fr") return fr_venue_tbc(inputs)
	if (locale === "tl") return tl_venue_tbc(inputs)
	if (locale === "vi") return vi_venue_tbc(inputs)
	if (locale === "ko") return ko_venue_tbc(inputs)
	if (locale === "de") return de_venue_tbc(inputs)
	if (locale === "ru") return ru_venue_tbc(inputs)
	if (locale === "tr") return tr_venue_tbc(inputs)
	if (locale === "it") return it_venue_tbc(inputs)
	if (locale === "pl") return pl_venue_tbc(inputs)
	if (locale === "uk") return uk_venue_tbc(inputs)
	if (locale === "hi") return hi_venue_tbc(inputs)
	if (locale === "ar") return ar_venue_tbc(inputs)
	if (locale === "ms") return ms_venue_tbc(inputs)
	if (locale === "bn") return bn_venue_tbc(inputs)
	if (locale === "zh-TW") return zh_tw2_venue_tbc(inputs)
	if (locale === "zh-HK") return zh_hk2_venue_tbc(inputs)
	if (locale === "ur") return ur_venue_tbc(inputs)
	if (locale === "fa") return fa_venue_tbc(inputs)
	if (locale === "sw") return sw_venue_tbc(inputs)
	if (locale === "nl") return nl_venue_tbc(inputs)
	return en_venue_tbc(inputs)
});